import Modal from "../shared/Modal";
import { Employee, EmployeeProfile, getDefaultUserAvatar } from "winslow-core";
import "./ModalMatchingEmployees.css";

type ModalMatchingEmployeesProps = {
  isOpen: boolean;
  onClose: () => void;
  employees: EmployeeProfile[] | Employee[];
  title?: string;
};

export const ModalMatchingEmployees = ({
  isOpen,
  onClose,
  employees,
  title,
}: ModalMatchingEmployeesProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "512px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="matching-employees-modal-container">
        <header className="matching-employees-modal-header">
          <h1 className="matching-employees-modal-title">
            {title ||
              (employees.length === 0
                ? "No Matching Employees"
                : employees.length === 1
                  ? "1 Matching Employee"
                  : `${employees.length} Matching Employees`)}
          </h1>
        </header>

        <div className="matching-employees-list">
          {employees.map((employee) => (
            <div key={employee.id} className="matching-employee-item">
              <img
                src={employee.avatar || ""}
                alt={getDefaultUserAvatar(employee.displayName)}
                className="matching-employee-avatar"
              />
              <span className="matching-employee-name">
                {employee.displayName}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
